import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';

export const ASSET_NAME = 'landing-page';
export const HERO_LISTING_SECTION_ID = 'shelfy-hero-books';
export const HERO_CANDIDATE_COUNT = 36;

const heroListingSection = {
  sectionId: HERO_LISTING_SECTION_ID,
  sectionType: 'listings',
  listingSelection: 'queryString',
};

const heroListingImageConfig = {
  aspectWidth: 3,
  aspectHeight: 4,
  variantPrefix: 'listing-card',
};

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(
      fetchFeaturedListings({
        sectionId: HERO_LISTING_SECTION_ID,
        parentPage: ASSET_NAME,
        listingType: 'book-listing',
        listingImageConfig: heroListingImageConfig,
        allSections: [heroListingSection],
        perPage: HERO_CANDIDATE_COUNT,
      })
    ),
  ]);
};
